module.exports = "/_next/static/images/sellers_3_ru-a8dea0f1252d7c2d19cc6f9034eb8b9a.png";